import { types } from 'mobx-state-tree';
import { debugError } from '../../logging/DebugLogger';
var Route = /** @class */ (function () {
    function Route(screenComponent, paramterDefinition) {
        this.screenComponent = screenComponent;
        this.paramterDefinition = paramterDefinition;
    }
    Object.defineProperty(Route.prototype, "parameterString", {
        get: function () {
            return Object.keys(this.paramterDefinition)
                .map(function (parameterName) { return ":" + parameterName; })
                .join('/');
        },
        enumerable: false,
        configurable: true
    });
    Route.prototype.getPath = function (routesDefinition) {
        var navigationName = this.customPathname || this.getNavigationName(routesDefinition);
        // we just want a slash before the parameters, if we have parameters
        var slashBeforeParameters = this.parameterString ? '/' : '';
        return "" + navigationName + slashBeforeParameters + this.parameterString;
    };
    Route.prototype.getNavigationName = function (routesDefinition) {
        return this.getNavigationNameByRoutesDefinition(routesDefinition);
    };
    Route.prototype.withCustomPathname = function (customPathname) {
        this.customPathname = customPathname;
        return this;
    };
    Route.prototype.toReactNavigationRoute = function (routesDefinitions) {
        return {
            screen: this.screenComponent,
            path: this.getPath(routesDefinitions)
        };
    }; // ToDo: NavigationRouteConfigMap<{}, NavigationSwitchProp>
    // #region private methods
    Route.prototype.getNavigationNameByRoutesDefinition = function (routesDefinition) {
        var _this = this;
        var NavigationName = Object.keys(routesDefinition).find(function (key) { return routesDefinition[key] === _this; });
        if (!NavigationName) {
            debugError('NavigationName could not be resolved for', {
                route: this,
                routesDefinition: routesDefinition
            });
            return 'unknown';
        }
        return NavigationName;
    };
    // #endregion
    // #region static route type generators
    Route.new = function (screenComponent) {
        // Screens without parameters have an empty parameter description
        var paramterDefinition = {};
        return new Route(screenComponent, paramterDefinition);
    };
    Route.idRoute = function (screenComponent) {
        // Screens without parameters have an empty parameter description
        var idParamterDefinition = { id: types.string };
        return new Route(screenComponent, idParamterDefinition);
    };
    return Route;
}());
export default Route;
//# sourceMappingURL=Route.js.map